export function moveMonth(month: string, amount: number): string {
  const date = new Date(`${month}-01T12:00:00Z`);
  date.setUTCMonth(date.getUTCMonth() + amount);
  return date.toISOString().slice(0, 7);
}

export function calendarDates(month: string): Array<string | null> {
  const first = new Date(`${month}-01T12:00:00Z`);
  const offset = (first.getUTCDay() + 6) % 7;
  const next = new Date(`${moveMonth(month, 1)}-01T12:00:00Z`);
  const count = Math.round((next.getTime() - first.getTime()) / 86_400_000);
  const cells: Array<string | null> = [...Array<null>(offset).fill(null), ...Array.from({ length: count }, (_, index) => `${month}-${String(index + 1).padStart(2, '0')}`)];
  while (cells.length % 7) cells.push(null);
  return cells;
}

